<template>
  <div>
    <v-card class="set-height-menu">
      <v-list v-for="item in menu" :key="item.title" class="padding-left"
              v-if="item.permission && item.permission !== permission.deny"
              v-model="item.active">
        <template v-if="item.subMenu.length > 0">
          <v-list-group
            v-on:click="
              () => {
                item.active ? (item.active = false) : (item.active = true);
              }
            "
            class="group-list-sidebar"
            :class="{ 'active-menu-list': item.active === true }"
            append-icon="fas fa-caret-down"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title" class="menus"></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="subItem in item.subMenu"
              v-if="subItem.permission && subItem.permission !== permission.deny"
              :key="subItem.title"
              @click="clickMainMenu(null)"
            >
              <span></span>
              <v-list-item-content class="sub-menu" @click="goToPath(subItem.path)">
                <v-list-item-title
                  v-text="subItem.title"
                  :class="{
                    'active-menu-item':
                      $route.path.includes(subItem.path) || $route.path.includes(subItem.path_edit)
                  }"
                >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <template v-else>
          <v-list-item style="margin-left: -23px" @click="clickMainMenu(item.path)">
            <v-list-item-icon>
              <!---icon--->
            </v-list-item-icon>
            <v-list-item-title v-text="item.title" class="menus">
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </div>
</template>
<script>
  import {
    permissionAbout, permissionBanner, permissionContact,
    permissionDesignWorldCalendar, permissionFaq, permissionFaqCategory,
    permissionFloor, permissionFreePage,
    permissionGroupVisit, permissionLandingPage, permissionLocation,
    permissionMainBranch,
    permissionMembership,
    permissionMembershipBenefit, permissionMembershipMember,
    permissionMembershipRate,
    permissionMenu,
    permissionMiniTCDC,
    permissionMiniTCDCType, permissionNetwork, permissionNews,
    permissionOnlineExhibition, permissionPartner,
    permissionResourceCenter,
    permissionRestaurant,
    permissionService,
    permissionServiceArea, permissionSponserProgram,
    permissionTravelInfo,
    permissionVenueHire,
    permissionVenueHireDetail,
    permissionUser,
    permissionUserRole,
    permissionSupportVenueHire,
    permissionSupportGroupVisit,
    permissionSupportContact,
    permissionOurService,
    role
  } from "../../util/Permission";
export default {
  name: "MenuSidebar",
  data() {
    return {
      permission : null,
      menu: [
        {
          title: "Customer Support",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "Venue Hire",
              path: "/customer-support/venue-hire",
              path_edit: "/customer-support/venue-hire/edit",
              permission : null,
              feature_id : 34,
            },
            {
              title: "Group Visit",
              path: "/customer-support/group-visit",
              path_edit: "/customer-support/group-visit/edit",
              permission : null,
              feature_id : 35,
            },
            {
              title: "Contact",
              path: "/customer-support/contact",
              path_edit: "/customer-support/contact/edit",
              permission : null,
              feature_id : 36,
            } ,
            // {
            //   title: "Subscribes",
            //   path: "/customer-support/subscribes",
            //   path_edit: "",
            //   permission : null,
            //   feature_id : 36,
            // }
          ]
        },
        {
          title: "Branch",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "Main Branch",
              path: "/branch/main-branch",
              path_edit: "/branch/edit",
              permission : null,
              feature_id : 1,
            },
            {
              title: "Mini TCDC",
              path: "/branch/mini-TCDC",
              path_edit: "/mini-tcdc/edit",
              permission : null,
              feature_id : 2,
            },
            {
              title: "Mini TCDC Type",
              path: "/branch/tcdc-mini-type",
              path_edit: "/tcdc-mini-type/edit",
              permission : null,
              feature_id : 3,
            }
          ]
        },
        {
          title: "Service",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "Service",
              path: "/services/service",
              path_edit: "/service/edit",
              permission : null,
              feature_id : 4,
            },
            {
              title: "Service area",
              path: "/services/service-area",
              path_edit: "/services-area/edit",
              permission : null,
              feature_id : 5,
            },
            {
              title: "Group visit",
              path: "/services/group-visit",
              path_edit: "/group-visit/edit",
              permission : null,
              feature_id : 6,
            },
            {
              title: "Travel Info",
              path: "/services/travel-info",
              path_edit: "/travel-info/edit",
              permission : null,
              feature_id : 7,
            },
            {
              title: "Restaurant",
              path: "/services/restaurant",
              path_edit: "/restaurant/edit",
              permission : null,
              feature_id : 8,
            },
            {
              title: "Venue hire",
              path: "/services/venue-hire",
              path_edit: "/venue-hire/edit",
              permission : null,
              feature_id : 9,
            },
            {
              title: "Venue hire detail",
              path: "/services/venue-hire-details",
              path_edit: "/venue-hire-details/edit",
              permission : null,
              feature_id : 10,
            },
            {
              title: "Floor",
              path: "/services/floor",
              path_edit: "/floor/edit",
              permission : null,
              feature_id : 11,
            }
          ]
        },
        {
          title: "Menu",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [{
            title: "Menu",
            path: "/menu/menu",
            path_edit: "/menu/edit" ,
            permission : null,
            feature_id: 12,
          }]
        },
        {
          title: "Resource center",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "Resource center Main",
              path: "/resource-center-main",
              permission : null,
              feature_id: 13,
            },
            {
              title: "Resource center",
              path: "/resource-center",
              path_edit: "/resource-center/edit",
              permission : null,
              feature_id: 13,
            },
            {
              title: "Online Exhibition",
              path: "/online-exhibition",
              path_edit: "/online-exhibition/edit" ,
              permission : null,
              feature_id: 14,
            },
            {
              title: "Design world calendar",
              path: "/design-world-calendar",
              path_edit: "/design-world-calendar/edit",
              permission : null,
              feature_id: 19,
            },
          ]
        },
        {
          title: "Membership",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "Membership Main",
              path: "/membership-main",
              permission : null,
              feature_id: 15,
            },
            {
              title: "Membership",
              path: "/membership",
              path_edit: "/membership/edit",
              permission : null,
              feature_id: 15,
            },
            {
              title: "Membership rate",
              path: "/membership/membership-rate",
              path_edit: "/membership-rate/edit",
              permission : null,
              feature_id: 16,
            },
            {
              title: "Membership benefit",
              path: "/membership/membership-benefit",
              path_edit: "/membership-benefit/edit",
              permission : null,
              feature_id: 17,
            },
            {
              title: "Member Information",
              path: "/membership/members",
              path_edit: "/members/edit",
              permission : null,
              feature_id: 18,
            },
          ]
        },
        // {
        //   title: "Design world calendar",
        //   active: false,
        //   path: "/design-world-calendar",
        //   path_edit: "/design-world-calendar/edit",
        //   permission : null,
        //   feature_id: 19,
        //   permission_feature :[],
        //   subMenu: []
        // },
        {
          title: "About",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "About Main",
              path: "/about-main",
              permission : null,
              feature_id: 20,
            },
            {
              title: "About",
              path: "/about/about",
              path_edit: "/about/edit",
              permission : null,
              feature_id: 20,
            },
            {
              title: "Network",
              path: "/about/network",
              path_edit: "/network/edit",
              permission : null,
              feature_id: 21,
            },
            {
              title: "News",
              path: "/about/news",
              path_edit: "/news/edit" ,
              permission : null,
              feature_id: 22,
            },
            {
              title: "Partner",
              path: "/about/partner",
              path_edit: "/partner/edit" ,
              permission : null,
              feature_id: 23,
            },
            {
              title: "Sponser program",
              path: "/about/sponser-program",
              path_edit: "/sponser-program/edit" ,
              permission : null,
              feature_id: 24,
            },
            {
              title: "Location",
              path: "/about/location",
              path_edit: "/location/edit" ,
              permission : null,
              feature_id: 25,
            },
            {
              title: "Contact",
              path: "/about/contact",
              path_edit: "/contact/edit" ,
              permission : null,
              feature_id: 26,
            }
          ]
        },
        {
          title: "Our service",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "Our service main",
              path: "/our-service-main",
              permission : null,
              feature_id: 37,
            },
            {
              title: "Our service",
              path: "/our-service",
              path_edit: "/our-service/edit",
              permission : null,
              feature_id: 37,
            }
          ]
        },
        {
          title: "FAQ",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "FAQ",
              path: "/fag/faqs",
              path_edit: "/faqs/edit" ,
              permission : null,
              feature_id: 27,
            },
            {
              title: "FAQ category",
              path: "/faq/faq-category",
              path_edit: "/faq-category/edit" ,
              permission : null,
              feature_id: 28,
            },
          ]
        },
        {
          title: "Banner",
          active: false,
          path: "/banner",
          path_edit: "/banner/edit",
          permission : null,
          feature_id: 29,
          permission_feature :[],
          subMenu: []
        },
        {
          title: "Landing page",
          active: false,
          path: "/landing-page",
          path_edit: "/landing-page/edit",
          permission : null,
          feature_id: 30,
          permission_feature :[],
          subMenu: []
        },
        {
          title: "Free page",
          active: false,
          path: "/free-page",
          path_edit: "/free-page/edit",
          permission : null,
          feature_id: 31,
          permission_feature :[],
          subMenu: []
        },
        {
          title: "User management",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "User",
              path: "/user",
              path_edit: "/user/edit" ,
              permission : null,
              feature_id: 32,
            },
            {
              title: "User role",
              path: "/user-role",
              path_edit: "/user-role/edit" ,
              permission : null,
              feature_id: 33,
            },
          ]
        },
        {
          title: "E-newsletter",
          active: false,
          permission : null,
          feature_id : null,
          permission_feature :[],
          subMenu: [
            {
              title: "Subscribed E-mail",
              path: "/email-subscriber",
              path_edit: "/email-subscriber/edit" ,
              permission : null,
              feature_id: 33,
            },
            {
              title: "Categories",
              path: "/enewsletter-categories",
              path_edit: "/enewsletter-categories/edit" ,
              permission : null,
              feature_id: 34,
            },
          ]
        }
      ]
    };
  },
  created() {
    this.permission = role;
    this.setPermissionMenu();
  },
  computed:{
    permissionMainBranch,
    permissionMiniTCDC,
    permissionMiniTCDCType,
    permissionService,
    permissionServiceArea,
    permissionGroupVisit,
    permissionTravelInfo,
    permissionRestaurant,
    permissionVenueHire,
    permissionVenueHireDetail,
    permissionFloor,
    permissionMenu,
    permissionResourceCenter,
    permissionOnlineExhibition,
    permissionMembership,
    permissionMembershipRate,
    permissionMembershipBenefit,
    permissionMembershipMember,
    permissionDesignWorldCalendar,
    permissionAbout,
    permissionNetwork,
    permissionNews,
    permissionPartner,
    permissionSponserProgram,
    permissionLocation,
    permissionContact,
    permissionFaq,
    permissionFaqCategory,
    permissionBanner,
    permissionLandingPage,
    permissionFreePage,
    permissionUser,
    permissionUserRole,
    permissionSupportVenueHire,
    permissionSupportGroupVisit,
    permissionSupportContact,
    permissionOurService,
  },
  methods: {
    setPermissionMenu(){
      //set permission in subMenu
      this.menu.forEach(main=>{
        main.subMenu.forEach(subMenu=>{
          if(permissionMainBranch && subMenu.feature_id == this.permissionMainBranch.feature_id){
            subMenu.permission = this.permissionMainBranch.permission_id
          }
          if(permissionMiniTCDC && subMenu.feature_id == this.permissionMiniTCDC.feature_id){
            subMenu.permission = this.permissionMiniTCDC.permission_id
          }
          if(permissionMiniTCDCType && subMenu.feature_id == this.permissionMiniTCDCType.feature_id){
            subMenu.permission = this.permissionMiniTCDCType.permission_id
          }
          if(permissionService && subMenu.feature_id == this.permissionService.feature_id){
            subMenu.permission = this.permissionService.permission_id
          }
          if(permissionServiceArea && subMenu.feature_id == this.permissionServiceArea.feature_id){
            subMenu.permission = this.permissionServiceArea.permission_id
          }
          if(permissionGroupVisit && subMenu.feature_id == this.permissionGroupVisit.feature_id){
            subMenu.permission = this.permissionGroupVisit.permission_id
          }
          if(permissionTravelInfo && subMenu.feature_id == this.permissionTravelInfo.feature_id){
            subMenu.permission = this.permissionTravelInfo.permission_id
          }
          if(permissionRestaurant && subMenu.feature_id == this.permissionRestaurant.feature_id){
            subMenu.permission = this.permissionRestaurant.permission_id
          }
          if(permissionVenueHire && subMenu.feature_id == this.permissionVenueHire.feature_id){
            subMenu.permission = this.permissionVenueHire.permission_id
          }
          if(permissionVenueHireDetail && subMenu.feature_id == this.permissionVenueHireDetail.feature_id){
            subMenu.permission = this.permissionVenueHireDetail.permission_id
          }
          if(permissionFloor && subMenu.feature_id == this.permissionFloor.feature_id){
            subMenu.permission = this.permissionFloor.permission_id
          }
          if(permissionMenu && subMenu.feature_id == this.permissionMenu.feature_id){
            subMenu.permission = this.permissionMenu.permission_id
          }
          if(permissionResourceCenter && subMenu.feature_id == this.permissionResourceCenter.feature_id){
            subMenu.permission = this.permissionResourceCenter.permission_id
          }
          if(permissionOnlineExhibition && subMenu.feature_id == this.permissionOnlineExhibition.feature_id){
            subMenu.permission = this.permissionOnlineExhibition.permission_id
          }
          if(permissionMembership && subMenu.feature_id == this.permissionMembership.feature_id){
            subMenu.permission = this.permissionMembership.permission_id
          }
          if(permissionMembershipRate && subMenu.feature_id == this.permissionMembershipRate.feature_id){
            subMenu.permission = this.permissionMembershipRate.permission_id
          }
          if(permissionMembershipBenefit && subMenu.feature_id == this.permissionMembershipBenefit.feature_id){
            subMenu.permission = this.permissionMembershipBenefit.permission_id
          }
          if(permissionMembershipMember && subMenu.feature_id == this.permissionMembershipMember.feature_id){
            subMenu.permission = this.permissionMembershipMember.permission_id
          }
          if(permissionDesignWorldCalendar && subMenu.feature_id == this.permissionDesignWorldCalendar.feature_id){
            subMenu.permission = this.permissionDesignWorldCalendar.permission_id
          }
          if(permissionAbout && subMenu.feature_id == this.permissionAbout.feature_id){
            subMenu.permission = this.permissionAbout.permission_id
          }
          if(permissionNetwork && subMenu.feature_id == this.permissionNetwork.feature_id){
            subMenu.permission = this.permissionNetwork.permission_id
          }
          if(permissionNews && subMenu.feature_id == this.permissionNews.feature_id){
            subMenu.permission = this.permissionNews.permission_id
          }
          if(permissionPartner && subMenu.feature_id == this.permissionPartner.feature_id){
            subMenu.permission = this.permissionPartner.permission_id
          }
          if(permissionSponserProgram && subMenu.feature_id == this.permissionSponserProgram.feature_id){
            subMenu.permission = this.permissionSponserProgram.permission_id
          }
          if(permissionLocation && subMenu.feature_id == this.permissionLocation.feature_id){
            subMenu.permission = this.permissionLocation.permission_id
          }
          if(permissionContact && subMenu.feature_id == this.permissionContact.feature_id){
            subMenu.permission = this.permissionContact.permission_id
          }
          if(permissionFaq && subMenu.feature_id == this.permissionFaq.feature_id){
            subMenu.permission = this.permissionFaq.permission_id
          }
          if(permissionFaqCategory && subMenu.feature_id == this.permissionFaqCategory.feature_id){
            subMenu.permission = this.permissionFaqCategory.permission_id
          }
          if(permissionBanner && subMenu.feature_id == this.permissionBanner.feature_id){
            subMenu.permission = this.permissionBanner.permission_id
          }
          if(permissionLandingPage && subMenu.feature_id == this.permissionLandingPage.feature_id){
            subMenu.permission = this.permissionLandingPage.permission_id
          }
          if(permissionFreePage && subMenu.feature_id == this.permissionFreePage.feature_id){
            subMenu.permission = this.permissionFreePage.permission_id
          }
          if(permissionUser && subMenu.feature_id == this.permissionUser.feature_id){
            subMenu.permission = this.permissionUser.permission_id
          }
          if(permissionUserRole && subMenu.feature_id == this.permissionUserRole.feature_id){
            subMenu.permission = this.permissionUserRole.permission_id
          }
          if(permissionSupportVenueHire && subMenu.feature_id == this.permissionSupportVenueHire.feature_id){
            subMenu.permission = this.permissionSupportVenueHire.permission_id
          }
          if(permissionSupportGroupVisit && subMenu.feature_id == this.permissionSupportGroupVisit.feature_id){
            subMenu.permission = this.permissionSupportGroupVisit.permission_id
          }
          if(permissionSupportContact && subMenu.feature_id == this.permissionSupportContact.feature_id){
            subMenu.permission = this.permissionSupportGroupVisit.permission_id
          }
          if(permissionOurService && subMenu.feature_id == this.permissionOurService.feature_id){
            subMenu.permission = this.permissionOurService.permission_id
          }
          if(subMenu.permission){
            main.permission_feature.push(subMenu.permission);
          }
        })
      })

      //set permission in MainMenu
      this.menu.forEach(main=>{
        if(main.subMenu.length == 0){
          if(permissionMainBranch && main.feature_id == this.permissionMainBranch.feature_id){
            main.permission = this.permissionMainBranch.permission_id
          }
          if(permissionMiniTCDC && main.feature_id == this.permissionMiniTCDC.feature_id){
            main.permission = this.permissionMiniTCDC.permission_id
          }
          if(permissionMiniTCDCType && main.feature_id == this.permissionMiniTCDCType.feature_id){
            main.permission = this.permissionMiniTCDCType.permission_id
          }
          if(permissionService && main.feature_id == this.permissionService.feature_id){
            main.permission = this.permissionService.permission_id
          }
          if(permissionServiceArea && main.feature_id == this.permissionServiceArea.feature_id){
            main.permission = this.permissionServiceArea.permission_id
          }
          if(permissionGroupVisit && main.feature_id == this.permissionGroupVisit.feature_id){
            main.permission = this.permissionGroupVisit.permission_id
          }
          if(permissionTravelInfo && main.feature_id == this.permissionTravelInfo.feature_id){
            main.permission = this.permissionTravelInfo.permission_id
          }
          if(permissionRestaurant && main.feature_id == this.permissionRestaurant.feature_id){
            main.permission = this.permissionRestaurant.permission_id
          }
          if(permissionVenueHire && main.feature_id == this.permissionVenueHire.feature_id){
            main.permission = this.permissionVenueHire.permission_id
          }
          if(permissionVenueHireDetail && main.feature_id == this.permissionVenueHireDetail.feature_id){
            main.permission = this.permissionVenueHireDetail.permission_id
          }
          if(permissionFloor && main.feature_id == this.permissionFloor.feature_id){
            main.permission = this.permissionFloor.permission_id
          }
          if(permissionMenu && main.feature_id == this.permissionMenu.feature_id){
            main.permission = this.permissionMenu.permission_id
          }
          if(permissionResourceCenter && main.feature_id == this.permissionResourceCenter.feature_id){
            main.permission = this.permissionResourceCenter.permission_id
          }
          if(permissionOnlineExhibition && main.feature_id == this.permissionOnlineExhibition.feature_id){
            main.permission = this.permissionOnlineExhibition.permission_id
          }
          if(permissionMembership && main.feature_id == this.permissionMembership.feature_id){
            main.permission = this.permissionMembership.permission_id
          }
          if(permissionMembershipRate && main.feature_id == this.permissionMembershipRate.feature_id){
            main.permission = this.permissionMembershipRate.permission_id
          }
          if(permissionMembershipBenefit && main.feature_id == this.permissionMembershipBenefit.feature_id){
            main.permission = this.permissionMembershipBenefit.permission_id
          }
          if(permissionMembershipMember && main.feature_id == this.permissionMembershipMember.feature_id){
            main.permission = this.permissionMembershipMember.permission_id
          }
          if(permissionDesignWorldCalendar && main.feature_id == this.permissionDesignWorldCalendar.feature_id){
            main.permission = this.permissionDesignWorldCalendar.permission_id
          }
          if(permissionAbout && main.feature_id == this.permissionAbout.feature_id){
            main.permission = this.permissionAbout.permission_id
          }
          if(permissionNetwork && main.feature_id == this.permissionNetwork.feature_id){
            main.permission = this.permissionNetwork.permission_id
          }
          if(permissionNews && main.feature_id == this.permissionNews.feature_id){
            main.permission = this.permissionNews.permission_id
          }
          if(permissionPartner && main.feature_id == this.permissionPartner.feature_id){
            main.permission = this.permissionPartner.permission_id
          }
          if(permissionSponserProgram && main.feature_id == this.permissionSponserProgram.feature_id){
            main.permission = this.permissionSponserProgram.permission_id
          }
          if(permissionLocation && main.feature_id == this.permissionLocation.feature_id){
            main.permission = this.permissionLocation.permission_id
          }
          if(permissionContact && main.feature_id == this.permissionContact.feature_id){
            main.permission = this.permissionContact.permission_id
          }
          if(permissionFaq && main.feature_id == this.permissionFaq.feature_id){
            main.permission = this.permissionFaq.permission_id
          }
          if(permissionFaqCategory && main.feature_id == this.permissionFaqCategory.feature_id){
            main.permission = this.permissionFaqCategory.permission_id
          }
          if(permissionBanner && main.feature_id == this.permissionBanner.feature_id){
            main.permission = this.permissionBanner.permission_id
          }
          if(permissionLandingPage && main.feature_id == this.permissionLandingPage.feature_id){
            main.permission = this.permissionLandingPage.permission_id
          }
          if(permissionFreePage && main.feature_id == this.permissionFreePage.feature_id){
            main.permission = this.permissionFreePage.permission_id
          }
          if(permissionUser && main.feature_id == this.permissionUser.feature_id){
            main.permission = this.permissionUser.permission_id
          }
          if(permissionUserRole && main.feature_id == this.permissionUserRole.feature_id){
            main.permission = this.permissionUserRole.permission_id
          }
          if(permissionSupportVenueHire && main.feature_id == this.permissionSupportVenueHire.feature_id){
            main.permission = this.permissionSupportVenueHire.permission_id
          }
          if(permissionSupportGroupVisit && main.feature_id == this.permissionSupportGroupVisit.feature_id){
            main.permission = this.permissionSupportGroupVisit.permission_id
          }
          if(permissionSupportContact && main.feature_id == this.permissionSupportContact.feature_id){
            main.permission = this.permissionSupportGroupVisit.permission_id
          }
          if(permissionOurService && main.feature_id == this.permissionOurService.feature_id){
            main.permission = this.permissionOurService.permission_id
          }
        }
        else {
          if(main.permission_feature.includes(2) || main.permission_feature.includes(1)){
            main.permission = 2;
          }else{
            main.permission = 3;
          }
        }
      })

    },
    clickMainMenu(path) {
      if(path){
        if (this.$route.path !== path) this.$router.push(path);
      }
    },
    goToPath(path) {
      if (path) {
        if (this.$route.path !== path) this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/css/variables.scss";
.group-list-sidebar {
  .v-icon.v-icon {
    font-size: 15px;
  }
}
.active-menu-list {
  background-color: $background-theme !important;
  border-left: 5px solid $submit-color;
  .v-list-group__items {
    background-color: white;
    border-left: #ffffff !important;
  }
}
.v-list-group__items {
  background-color: white !important;
  border-left: 3px solid #ffffff !important;
  margin-left: -10px;
}
</style>
<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
.theme--light.v-list {
  background: #ffffff;
  color: #000000;
}
div .v-list-item__title {
  color: #000000;
}
.sub-menu {
  margin-left: 30px;
}
.menus {
  font-weight: bold;
}
.set-height-menu {
  height: calc(100vh - 60px);
  background: #ffffff;
  color: #000000;
  width: 20%; /*20*/
  border-color: white !important;
}
.v-list-item__title {
  /*font-size: 20px;*/
}
.v-list-item__icon{
  min-width: 0 !important;
  margin-right: 24px !important;
}
.v-card {
  display: block;
  max-width: 100%;
  outline: none;
  text-decoration: none;
  -webkit-transition-property: opacity, -webkit-box-shadow;
  overflow-wrap: break-word;
  position: fixed; /*fixed*/
  overflow-y: auto;
  -webkit-transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: box-shadow;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14),
    0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}
@media screen and (max-width: 800px) {
  //for mobile
  .v-card {
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    -webkit-transition-property: opacity, -webkit-box-shadow;
    overflow-wrap: break-word;
    position: absolute;
    -webkit-transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    will-change: box-shadow;
    -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14),
      0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  }
  .set-height-menu {
    height: calc(100vh - 10px);
    background: #ffffff;
    color: #000000;
    width: 100%;
    border-color: white !important;
    position: relative;
  }
}
.active-menu-item {
  color: $submit-color !important;
  font-size: 18px;
}
.padding-left {
  padding-left: 20px;
}
</style>
